import { IntlShape } from 'react-intl'
import { separator } from '../modules/panel/core/globals'
/**
 * returns breadcrumbs array 
 * @param intl Intl object for internationalization
 * @param key 
 * @returns breadcrumbs array
 */
export const getBreadcrumbs = (intl: IntlShape, key: string) => {
  const breadCrumbsData = {
    viewTransaction: [
      {
        title: intl.formatMessage({ id: 'MENU.PURCHASES' }),
        path: `/transactions`,
        isActive: false,
      },
      separator,
    ],
    viewStore: [
      {
        title: intl.formatMessage({ id: 'STORES.LIST' }),
        path: `/stores-management`,
        isActive: false,
      },
      separator,
    ],
    viewRole: [
      {
        title: intl.formatMessage({ id: 'ROLES.LIST' }),
        path: `/users-management/roles`,
        isActive: false,
      },
      separator,
    ],
    viewPayment: [
      {
        title: intl.formatMessage({ id: 'MENU.PAYMENTS' }),
        path: `/payments`,
        isActive: false,
      },
      separator,
    ],
    viewPromotion: [
      {
        title: intl.formatMessage({ id: 'MENU.PROMOTIONS' }),
        path: `/promotions`,
        isActive: false,
      },
      separator,
    ],
    viewPromotionTransaction: [
      {
        title: intl.formatMessage({ id: 'MENU.COUPON_TRANSACTIONS' }),
        path: `/promotions/transactions`,
        isActive: false,
      },
      separator,
    ],
    viewPaymentScheme: [
      {
        title: intl.formatMessage({ id: 'MENU.PAYMENT_SCHEMES' }),
        path: `/payments/schemes`,
        isActive: false,
      },
      separator,
    ],
  }

  return breadCrumbsData?.[key] ?? []
}
